import { twMerge } from "tailwind-merge";

import {
  ALL_HEALTH_HISTORY_IDS,
  HEALTH_HISTORY_IDS,
  PREVIEW_TITLE_CODES,
} from "~/providers/constants/SummariesExpandableIds";
import { SymptomsProgressionOverTime } from "~/providers/utils/types/patientIntakePreviewTypes";
import Expandable from "../common/Expandable";
import { PatientPreviewSymptomProgressionV2 } from "./PatientPreviewSymptomProgressionV2";

interface HealthHistoryProps {
  history_of_present_illness: string;
  psychiatric_history: string;
  medical_history: string;
  symptoms_progression_over_time: SymptomsProgressionOverTime[];
}

export const HealthHistory = ({
  history_of_present_illness,
  medical_history,
  psychiatric_history,
  symptoms_progression_over_time,
}: HealthHistoryProps) => (
  <Expandable.Wrapper
    code={PREVIEW_TITLE_CODES.HEALTH_HISTORY}
    expandableSections={[...ALL_HEALTH_HISTORY_IDS]}
  >
    <Expandable.Section code={HEALTH_HISTORY_IDS.HISTORY_OF_PRESENT_ILLNESS}>
      {history_of_present_illness}
    </Expandable.Section>

    <Expandable.Section code={HEALTH_HISTORY_IDS.PSYCHIATRIC_HISTORY}>
      {psychiatric_history}
    </Expandable.Section>

    <Expandable.Section
      code={HEALTH_HISTORY_IDS.MEDICAL_HISTORY}
      className={twMerge(!symptoms_progression_over_time && "border-none pb-0")}
    >
      {medical_history}
    </Expandable.Section>

    {symptoms_progression_over_time && (
      <Expandable.Section
        code={HEALTH_HISTORY_IDS.SYMPTOM_PROGRESSION_OVER_TIME}
        className="border-none pb-0"
      >
        <PatientPreviewSymptomProgressionV2
          symptomProgression={symptoms_progression_over_time}
        />
      </Expandable.Section>
    )}
  </Expandable.Wrapper>
);
